//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      navTitle: '加载中...',
      navurl: '',
      webviewStyles: {
        progress: {
          color: "#FF3333"
        }
      }
    };
  },
  created() {
    // 新增参数校验，避免空值
    const query = this.$route.query || {};
    this.navTitle = query.title || '加载中...';
    this.navurl = query.url || ''; 
  },
  methods: {
    goBack() {
      this.$router && this.$router.back();
    }
  }
};



// WEBPACK FOOTER //
// ./src/views/publicView/me/yhfwxy_display.vue